var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import classnames from "classnames";
import { Button } from "@riseart/common";
import { artFrameItemCls, artFrameItemBorderCls, artFrameItemInnerCls, artFrameItemSelectedCls, artFrameItemColorNoneCls, artFrameItemColorWhiteCls, artFrameItemColorBlackCls, artFrameItemColorWalnutCls, artFrameItemCircleCls, artFrameItemSquareCls } from "./Item.less";
var shapeToClassName = {
  circle: artFrameItemCircleCls,
  square: artFrameItemSquareCls
};
var colorToClassName = {
  none: artFrameItemColorNoneCls,
  white: artFrameItemColorWhiteCls,
  black: artFrameItemColorBlackCls,
  walnut: artFrameItemColorWalnutCls
};
var ArtFrameItem = /* @__PURE__ */ __name(function ArtFrameItem2(_ref) {
  var _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? "square" : _ref$shape, _ref$color = _ref.color, color = _ref$color === void 0 ? "white" : _ref$color, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
  return /* @__PURE__ */ React.createElement(Button, {
    className: classnames(artFrameItemCls, className, shapeToClassName[shape], colorToClassName[color], _defineProperty({}, artFrameItemSelectedCls, isActive)),
    onClick,
    type: "link",
    width: "auto"
  }, /* @__PURE__ */ React.createElement("span", {
    className: artFrameItemBorderCls
  }, /* @__PURE__ */ React.createElement("span", {
    className: artFrameItemInnerCls
  }, /* @__PURE__ */ React.createElement("span", null, children))));
}, "ArtFrameItem");
export {
  ArtFrameItem
};
